module.exports = __webpack_public_path__ + "static/img/sweers.b32208e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/sweers.png
// module id = KxMD
// module chunks = 0